let content_blocks = require('../contents');

export function init(){
    
    $('#edit_form_modal .btn.delete').on('click', function(){
        let modal = $(this).closest('.modal');
        let block_id = modal.find('[name="block_id"]').val();
        $('#'+block_id).remove();
        content_blocks.show_start_block();
        content_blocks.show_block_order();

        modal.modal('hide');

        modal.find('form')[0].reset();
    });

    $('#edit_form_modal').on('show.bs.modal', function (event) {
        let form = $(event.relatedTarget);
        let block = $(form).closest('.block');
        let modal = $(this);
        modal.find('[name="block_id"]').val(block.attr('id'));
        modal.find('[name="classes"]').val(block.attr('data-class'));
        let _form = JSON.parse(block.attr('data-form'));
        let select =  modal.find('[name="form_id"]');
        // form = { id: "5", text: 'soy el 5' }
        select.select2("trigger", "select", {
            data : _form
        });
        
        let select_visible = modal.find('[name="visible"]');
        if (block.attr('data-visible') != null || block.attr('data-visible') != 'undefined') {
            select_visible.find('option[value="'+ block.attr('data-visible')).prop('selected', true);
        } else {
            select_visible.find('option[value="visible"]').prop('selected', true);
        }
        
        select_visible.select2({
            minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
            theme: 'bootstrap',
            width: 'resolve',
        });
    });

    $('#edit_form').on('submit', function (e) {
        e.preventDefault();
        let block = $('#'+ $(this).find('[name="block_id"]').val());
        let form_id = $(this).find('[name="form_id"]').val();
        let form_text = $(this).find('[name="form_id"]').find(':selected').text();
        let form = {
            id: form_id,
            text: form_text
        }
        
        block.attr('data-form', JSON.stringify(form));
        block.attr('data-class', $(this).find('[name="classes"]').val());
        block.attr('data-visible', $(this).find('[name="visible"]').val());

        get_form_preview(form_id, block);        
        
        let url = window._routes['microsites.forms.show'].replace('{microsite}', window.microsite_id).replace('{form}', form.id+'#form_fields');
        let button = block.find('.card-header .editForm');
        button.attr('href', url);
        content_blocks.change_visible_button_blocks(block);

        let modal = $(this).closest('.modal');
        modal.modal('hide');
    });

    $('.block[data-type="form"]').each(function(){
        init_form_block($(this).attr('id'));
        content_blocks.create_visible_button_blocks($(this));
    });
}

export function init_form_block(block_id) {

    let block = $('#content_blocks #' + block_id);

    if (block.attr('data-form') == '' || block.attr('data-form') == 'undefined') {
        let button = '<button type="button" class="btn btn-primary edit" data-toggle="modal" data-target="#edit_form_modal">'+ window.__('Añadir formulario') +'</button>';
        let form_container = block.find('.form_container');
        form_container.addClass(['d-flex', 'justify-content-center']);
        form_container.append(button);
    } else {
        let form = JSON.parse(block.attr('data-form'));
        get_form_preview(form.id, block);

        let url = window._routes['microsites.forms.show'].replace('{microsite}', window.microsite_id).replace('{form}', form.id+'#form_fields');
        let button = block.find('.card-header .editForm');
        button.attr('href', url);
    }

}

export function filter_forms(data) {    
    let results = $.map(data.results, function(obj, index) {
        return { 
            id: obj.id, 
            text: obj.name,
            result: obj.name
        };
    });

    return {
        results: results
    };
}

function get_form_preview(form_id, block) {

    let url = window._routes['microsites.contents.get_form_preview'].replace('{microsite}', window.microsite_id).replace('{form}', form_id);

    axios.get(url)
        .then((response) => {
            let form_container = block.find('.form_container');
            form_container.html(response.data);
        })
        .catch((error) => {
            console.log('ERROR', error);
        })
        .finally(() => {
        });
}